import { z } from 'zod';
import { Table, TableSchema } from './table';

export enum QuestionType {
  TEXT = 'text',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
}

export const AdditionalQuestionSchema = z.object({
  id: z.string(),
  type: z.nativeEnum(QuestionType).optional(),
  answer: z
    .union([z.string(), z.boolean(), z.number(), z.array(z.union([z.string(), z.boolean(), z.number()]))])
    .optional(),
});

export const GuestSchema = z.object({
  id: z.string(),
  name: z.string(),
  surname: z.string(),
  presence: z.boolean().optional(),
  connection: z.string(),
  connectedGuestId: z.string(),
  additionalQuestions: z.array(AdditionalQuestionSchema),
  tableNumber: z.number().optional(),
  tableAdditionalInfo: z.string().optional(),
  tableLayoutInfo: TableSchema.optional(),
  seatIndex: z.number().optional(),
});

export type AdditionalQuestion = z.infer<typeof AdditionalQuestionSchema>;
export type Guest = z.infer<typeof GuestSchema>;

export const isGuestEligibleForTableAssignment = (guest: Guest): boolean => guest.presence !== false;

export class GuestClass implements Guest {
  id: string;
  name: string;
  surname: string;
  presence?: boolean | undefined;
  connection: string;
  connectedGuestId: string;
  additionalQuestions: Array<AdditionalQuestion>;
  tableNumber?: number | undefined;
  tableAdditionalInfo?: string | undefined;
  tableLayoutInfo?: Table | undefined;
  seatIndex?: number | undefined;

  constructor(data?: Partial<Guest>) {
    const parsedData = GuestSchema.partial().parse(data || {});
    this.id = parsedData.id ?? '';
    this.name = parsedData.name ?? '';
    this.surname = parsedData.surname ?? '';
    this.presence = parsedData.presence;
    this.connection = parsedData.connection ?? '';
    this.connectedGuestId = parsedData.connectedGuestId ?? '';
    this.additionalQuestions = parsedData.additionalQuestions ?? [];
    this.tableNumber = parsedData.tableNumber;
    this.tableAdditionalInfo = parsedData.tableAdditionalInfo;
    this.tableLayoutInfo = parsedData.tableLayoutInfo;
    this.seatIndex = parsedData.seatIndex;
  }
}
